import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/theme/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "iframes"
    }}>{`iFrames`}</h1>
    <undefined>{`
          `}<div {...{
        "className": "gatsby-resp-iframe-wrapper",
        "style": {
          "paddingBottom": "66.66666666666666%",
          "position": "relative",
          "height": "0px",
          "overflow": "hidden"
        }
      }}>{`
            `}<iframe parentName="div" {...{
          "src": "http://www.example.com/",
          "style": {
            "position": "absolute",
            "top": "0px",
            "left": "0px",
            "width": "100%",
            "height": "100%"
          }
        }}></iframe>{`
          `}</div>{`
          `}</undefined>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<iframe src="http://www.example.com/" width="600" height="400"></iframe>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      